// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"233":"productpage","318":"grouppage","443":"about","490":"memberpage"}[chunkId] + "-legacy." + {"233":"2489e658","318":"361dfe4e","443":"cc41a39f","490":"0c8dd554"}[chunkId] + ".js";
};